export default function UserIcon({color}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="74"
      viewBox="0 0 74 74"
      fill="none"
    >
      <path
        d="M48.7783 42.735C45.2782 45.0284 41.1846 46.2501 37 46.2501C32.8154 46.2501 28.7218 45.0284 25.2217 42.735C20.7083 44.8569 16.8501 48.1559 14.0531 52.285C11.256 56.4141 9.62344 61.2207 9.32708 66.1992C9.31347 66.4101 9.34341 66.6216 9.41502 66.8205C9.48662 67.0195 9.59838 67.2015 9.74333 67.3554C9.88841 67.5076 10.0631 67.6285 10.2566 67.7107C10.4502 67.7929 10.6585 67.8346 10.8687 67.8333H63.2083C63.4186 67.8346 63.6269 67.7929 63.8204 67.7107C64.014 67.6285 64.1887 67.5076 64.3337 67.3554C64.4787 67.2015 64.5905 67.0195 64.6621 66.8205C64.7337 66.6216 64.7636 66.4101 64.75 66.1992C64.4464 61.2125 62.8023 56.4004 59.9912 52.2705C57.1801 48.1406 53.3061 44.8462 48.7783 42.735Z"
        fill={color|| "#42C3CF"}
      />
      <path
        d="M37 43.1667C47.2173 43.1667 55.5 34.884 55.5 24.6667C55.5 14.4494 47.2173 6.16669 37 6.16669C26.7827 6.16669 18.5 14.4494 18.5 24.6667C18.5 34.884 26.7827 43.1667 37 43.1667Z"
        fill={color|| "#42C3CF"}
      />
    </svg>
  );
}
